// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.grid-item {
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}
.grid-item a {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}

.grid-item p {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
}
.logoMapa {
  margin-top: 5px;
  width: 6rem;
  height: 1.81rem;
}
.btn-container {
  display: flex;
  align-items: center;
  background-color: #f2f2f2;
  max-height: 40px;
  border-radius: 10px;
}

.btn-container button {
  margin-right: 10px;
}

.container-nav-lateral-direito {
  position: fixed;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 1rem;
  flex-flow: column;
  align-items: end;
  z-index: 0;
  max-width: 0 !important;
  transform: translate(33vw, 5vh);
}

.container-nav-lateral-direito-items {
  position: relative;
  margin-right: 10px;
}

.container-nav-lateral-modal-raio {
  display: flex;
  gap: 1rem;
  padding-left: 20px;
  flex-direction: row-reverse;
}

.circular-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  /* border-radius: 50%; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #f7f7f7;
  border: none;
  outline: none;
  cursor: pointer;
}

.button-icon {
  width: 50px;
  height: 50px;
}
.menu {
  position: static;
  bottom: -200px;
  transform: translateX(-50%);
  background-color: #fff;
  width: 400px;
  height: 400px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10%;
}

.filtros-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 80px;
  border-radius: 30%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #f7f7f7;
  border: none;
  outline: none;
  cursor: pointer;
}

/* .filtro {
  left: 0% !important;
  right: 0% !important;
  top: 0% !important;
  bottom: 0% !important;
  height: 10vh !important;
  background-color: #ffffff !important;
  box-shadow: 4.33px 4.33px 6.18px rgba(1, 1, 1, 0.15) !important;
} */

/* .button-container {
  position: relative;
  display: inline-block;
} */

/* ul {
  list-style: none;
  padding: 0;
  margin: 0;
} */

.textoEstab {
  /* Text/Small text */

  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 10px;
  /* or 100% */

  display: flex;
  align-items: center;
  text-align: center;

  /* Gray / 9 */

  color: #212529;
}

.card {
  border: none !important;
}

.modalRaio {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px 10px 0 0;
  min-height: 30%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  background-color: #f7f7f7;
  border: none;
  outline: none;
  cursor: pointer;
  min-width: 8vw;
  padding: 7px;
}

.modalLoja {
  border-radius: 10px !important;
  min-width: 15vw;
  min-height: 7vh;
  box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 1%;
  margin-top: 20px;
  transform: translate(-10%, 0%);
}

.textoRaio {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;

  /* Gray / 7 */

  color: #69737d;
}

.textoKm {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;

  /* Gray / 7 */

  color: #69737d;
}
/* body {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  transform: scale(5);
} */
.marcadorLateralModalLoja {
  min-width: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.filtro-slider {
  transform: translate(0, 10vh);
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .modalRaio {
    min-width: 20vw;
  }

  .modalLoja {
    transform: translate(0, 3vh);
    min-width: 80vw;
  }

  .container-nav-lateral-direito {
    transform: translate(40vw, 5vh);
  }
  .filtro-slider {
    transform: translate(0, 70vh);
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .modalRaio {
    min-width: 17vw;
  }

  .modalLoja {
    min-width: 30vw;
    min-height: 10vh;
  }

  .container-nav-lateral-direito {
    transform: translate(46vw, 5vh);
  }

  .filtro-slider {
    transform: translate(0, 76vh);
  }
}

@media only screen and (min-width: 1030px) and (max-width: 1280px) {
  .modalRaio {
    min-width: 15vw;
  }

  .modalLoja {
    min-width: 25vw;
    min-height: 10vh;
  }

  .container-nav-lateral-direito {
    transform: translate(45vw, 5vh);
  }

  .filtro-slider {
    transform: translate(8vw, 70vh);
  }
}

@media only screen and (min-width: 1366px) and (max-width: 1920px) {
  .container-nav-lateral-direito {
    transform: translate(40vw, 5vh);
  }

  .filtro-slider {
    transform: translate(5vw, 78vh);
  }
}

@media only screen and (min-width: 2560px) and (max-width: 3840px) {
  .container-nav-lateral-direito {
    transform: translate(30vw, 5vh);
  }

  .filtro-slider {
    transform: translate(0, 80vh);
  }
}


.gm-ui-hover-effect {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/Views/Mapa/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;;;;GAQG;;AAEH;;;GAGG;;AAEH;;;;GAIG;;AAEH;EACE,oBAAoB;;EAEpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;;EAEb,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,8CAA8C;EAC9C,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;;EAEb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;;EAEb,cAAc;AAChB;AACA;;;;;;GAMG;AACH;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;;AAGA;EACE,wBAAwB;AAC1B","sourcesContent":[".grid-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.grid-item {\n  display: grid;\n  grid-template-columns: 100px 1fr;\n  align-items: center;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.grid-item a {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n\n.grid-item p {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n}\n.logoMapa {\n  margin-top: 5px;\n  width: 6rem;\n  height: 1.81rem;\n}\n.btn-container {\n  display: flex;\n  align-items: center;\n  background-color: #f2f2f2;\n  max-height: 40px;\n  border-radius: 10px;\n}\n\n.btn-container button {\n  margin-right: 10px;\n}\n\n.container-nav-lateral-direito {\n  position: fixed;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 1rem;\n  flex-flow: column;\n  align-items: end;\n  z-index: 0;\n  max-width: 0 !important;\n  transform: translate(33vw, 5vh);\n}\n\n.container-nav-lateral-direito-items {\n  position: relative;\n  margin-right: 10px;\n}\n\n.container-nav-lateral-modal-raio {\n  display: flex;\n  gap: 1rem;\n  padding-left: 20px;\n  flex-direction: row-reverse;\n}\n\n.circular-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  height: 100px;\n  /* border-radius: 50%; */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  background-color: #f7f7f7;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.button-icon {\n  width: 50px;\n  height: 50px;\n}\n.menu {\n  position: static;\n  bottom: -200px;\n  transform: translateX(-50%);\n  background-color: #fff;\n  width: 400px;\n  height: 400px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 10%;\n}\n\n.filtros-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100px;\n  height: 80px;\n  border-radius: 30%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  background-color: #f7f7f7;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n/* .filtro {\n  left: 0% !important;\n  right: 0% !important;\n  top: 0% !important;\n  bottom: 0% !important;\n  height: 10vh !important;\n  background-color: #ffffff !important;\n  box-shadow: 4.33px 4.33px 6.18px rgba(1, 1, 1, 0.15) !important;\n} */\n\n/* .button-container {\n  position: relative;\n  display: inline-block;\n} */\n\n/* ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n} */\n\n.textoEstab {\n  /* Text/Small text */\n\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 10px;\n  /* or 100% */\n\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  /* Gray / 9 */\n\n  color: #212529;\n}\n\n.card {\n  border: none !important;\n}\n\n.modalRaio {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px 10px 0 0;\n  min-height: 30%;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);\n  background-color: #f7f7f7;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  min-width: 8vw;\n  padding: 7px;\n}\n\n.modalLoja {\n  border-radius: 10px !important;\n  min-width: 15vw;\n  min-height: 7vh;\n  box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  border-radius: 1%;\n  margin-top: 20px;\n  transform: translate(-10%, 0%);\n}\n\n.textoRaio {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  /* Gray / 7 */\n\n  color: #69737d;\n}\n\n.textoKm {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  /* Gray / 7 */\n\n  color: #69737d;\n}\n/* body {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 100vh;\n  transform: scale(5);\n} */\n.marcadorLateralModalLoja {\n  min-width: 70px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.filtro-slider {\n  transform: translate(0, 10vh);\n}\n\n@media only screen and (min-width: 320px) and (max-width: 480px) {\n  .modalRaio {\n    min-width: 20vw;\n  }\n\n  .modalLoja {\n    transform: translate(0, 3vh);\n    min-width: 80vw;\n  }\n\n  .container-nav-lateral-direito {\n    transform: translate(40vw, 5vh);\n  }\n  .filtro-slider {\n    transform: translate(0, 70vh);\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n  .modalRaio {\n    min-width: 17vw;\n  }\n\n  .modalLoja {\n    min-width: 30vw;\n    min-height: 10vh;\n  }\n\n  .container-nav-lateral-direito {\n    transform: translate(46vw, 5vh);\n  }\n\n  .filtro-slider {\n    transform: translate(0, 76vh);\n  }\n}\n\n@media only screen and (min-width: 1030px) and (max-width: 1280px) {\n  .modalRaio {\n    min-width: 15vw;\n  }\n\n  .modalLoja {\n    min-width: 25vw;\n    min-height: 10vh;\n  }\n\n  .container-nav-lateral-direito {\n    transform: translate(45vw, 5vh);\n  }\n\n  .filtro-slider {\n    transform: translate(8vw, 70vh);\n  }\n}\n\n@media only screen and (min-width: 1366px) and (max-width: 1920px) {\n  .container-nav-lateral-direito {\n    transform: translate(40vw, 5vh);\n  }\n\n  .filtro-slider {\n    transform: translate(5vw, 78vh);\n  }\n}\n\n@media only screen and (min-width: 2560px) and (max-width: 3840px) {\n  .container-nav-lateral-direito {\n    transform: translate(30vw, 5vh);\n  }\n\n  .filtro-slider {\n    transform: translate(0, 80vh);\n  }\n}\n\n\n.gm-ui-hover-effect {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
